import { useEffect, useState } from "react";
import { Keyboard, type KeyboardEvent } from "react-native";

/**
 * Tracks the on-screen keyboard height via Keyboard show/hide events.
 * Pass `enabled: false` (e.g. when a modal is closed) to reset and unsubscribe.
 */
export function useKeyboardHeight(enabled = true) {
    const [keyboardHeight, setKeyboardHeight] = useState(0);

    useEffect(() => {
        if (!enabled) {
            setTimeout(() => {
                setKeyboardHeight(0);
            }, 0);
            return;
        }

        // Fresh enable (e.g. modal just opened) — never keep a stale height.
        setTimeout(() => {
            setKeyboardHeight(0);
        }, 0);

        function onKeyboardDidShow(event: KeyboardEvent) {
            setKeyboardHeight(event.endCoordinates.height);
        }

        function onKeyboardDidHide() {
            setKeyboardHeight(0);
        }

        const showSubscription = Keyboard.addListener(
            "keyboardDidShow",
            onKeyboardDidShow,
        );
        const hideSubscription = Keyboard.addListener(
            "keyboardDidHide",
            onKeyboardDidHide,
        );

        return () => {
            showSubscription.remove();
            hideSubscription.remove();
        };
    }, [enabled]);

    return {
        keyboardHeight,
        isKeyboardVisible: keyboardHeight > 0,
    };
}
